module.exports = __webpack_public_path__ + "img/folios--avatar.08a25e57.svg";